"use strict";

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, FileUpload, Modal } from 'framework-ui-components';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';

const ModaleAllegaRicevuta = ({ codiceUfficio, idDichiarazione, onClose }) => {
    const fileCaricato = x => {
        if (x.Success) {
            SnackbarManager.notifySuccess("Ricevuta Allegata");
            onClose();
        } else {
            SnackbarManager.notifyError(x.DetectedProblems);
        }
    }

    return (
        <Modal show onClose={onClose}>
            <Modal.Header>Allega ricevuta</Modal.Header>
            <Modal.Body>
                <p>Carica la ricevuta della tua dichiarazione di successione</p>
                <div className="text--center">
                    <FileUpload url={'/Successioni/AllegaRicevuta?idDichiarazione=' + idDichiarazione + "&studio=" + codiceUfficio}
                        accept={['.rel']}
                        onFileUploaded={fileCaricato}
                    >
                        <Button primary block>Allega Ricevuta</Button>
                    </FileUpload>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button flat onClick={onClose}>Chiudi</Button>
            </Modal.Footer>
        </Modal>
    );
};

ModaleAllegaRicevuta.propTypes = {
    codiceUfficio: PropTypes.string,
    idDichiarazione: PropTypes.string,
    onClose: PropTypes.func
};

export default ModaleAllegaRicevuta;